import { render, staticRenderFns } from "./CriaQRCode.vue?vue&type=template&id=ff2ddf50"
import script from "./CriaQRCode.vue?vue&type=script&lang=js"
export * from "./CriaQRCode.vue?vue&type=script&lang=js"
import style0 from "./CriaQRCode.vue?vue&type=style&index=0&id=ff2ddf50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports